import { render, staticRenderFns } from "./CourseLecture.vue?vue&type=template&id=80f8a846"
import script from "./CourseLecture.vue?vue&type=script&lang=ts"
export * from "./CourseLecture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports